import { Theme } from '@emotion/react';
import React from 'react';

import { useTranslations } from '../commons/utils/translations/translate';
import { useGlobalState, useSessionState } from '../global-state';
import { Heading } from '../ui/heading';

const CartSizeText: React.FC = () => {
  const { tICU } = useTranslations();
  const session = useSessionState();

  if (!session.cart.items || session.cart.items.length === 0) {
    return null;
  }

  const cartSize = session.cart.items.reduce((sum, item) => {
    return sum + (item.quantity ?? 1);
  }, 0);

  return <span css={styles.cartSize}>{` (${tICU('widget.cart.ITEM', { no: cartSize })})`}</span>;
};

export const SessionHeading: React.FC = () => {
  const globalState = useGlobalState();
  const session = useSessionState();
  const { tICU } = useTranslations();

  if (globalState.sessions.length === 1 && !session.cart.header) {
    /*
     * Weak heuristic for old-style single session header. No header means old
     * api, no group, or one group w/o header.
     */
    if (!session.flags.show_shipping_options_header) {
      return null;
    }

    return <Heading>{tICU('widget.SHIPPING_CATEGORY_LIST_HEADER')}</Heading>;
  }

  let header = session.cart.header;
  if (!header) {
    const cartIndex = globalState.sessions.findIndex(
      ({ session_id }) => session_id === session.session_id
    );
    header = `${tICU('widget.SPLIT_SHIPMENT_CART_HEADER')} ${cartIndex + 1}`;
  }

  return (
    <Heading>
      <span>{header}</span>
      <CartSizeText />
    </Heading>
  );
};

const styles = {
  cartSize: (theme: Theme) => ({
    color: theme.neutral35,
  }),
};
